// src/icons/CircularOutlineCheckIcon.tsx
import { jsx, jsxs } from "react/jsx-runtime";
function CircularOutlineCheckIcon({
  title,
  titleId,
  ...props
}) {
  return /* @__PURE__ */ jsxs("svg", {
    "aria-hidden": "true",
    "aria-labelledby": titleId,
    fill: "none",
    height: 24,
    viewBox: "0 0 25 24",
    width: 25,
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", {
        id: titleId,
        children: title
      }) : null,
      /* @__PURE__ */ jsx("path", {
        d: "M11.025 14.275L8.575 11.825C8.425 11.675 8.24167 11.6 8.025 11.6C7.80833 11.6 7.61667 11.6833 7.45 11.85C7.3 12 7.225 12.1833 7.225 12.4C7.225 12.6167 7.3 12.8 7.45 12.95L10.5 16.025C10.65 16.175 10.825 16.25 11.025 16.25C11.225 16.25 11.4 16.175 11.55 16.025L17.525 10.05C17.6917 9.88333 17.775 9.69167 17.775 9.475C17.775 9.25833 17.6917 9.06667 17.525 8.9C17.3583 8.75 17.1625 8.67917 16.9375 8.6875C16.7125 8.69583 16.525 8.775 16.375 8.925L11.025 14.275ZM12.5 22C11.1333 22 9.84167 21.7375 8.625 21.2125C7.40833 20.6875 6.34583 19.9708 5.4375 19.0625C4.52917 18.1542 3.8125 17.0917 3.2875 15.875C2.7625 14.6583 2.5 13.3667 2.5 12C2.5 10.6167 2.7625 9.31667 3.2875 8.1C3.8125 6.88333 4.52917 5.825 5.4375 4.925C6.34583 4.025 7.40833 3.3125 8.625 2.7875C9.84167 2.2625 11.1333 2 12.5 2C13.8833 2 15.1833 2.2625 16.4 2.7875C17.6167 3.3125 18.675 4.025 19.575 4.925C20.475 5.825 21.1875 6.88333 21.7125 8.1C22.2375 9.31667 22.5 10.6167 22.5 12C22.5 13.3667 22.2375 14.6583 21.7125 15.875C21.1875 17.0917 20.475 18.1542 19.575 19.0625C18.675 19.9708 17.6167 20.6875 16.4 21.2125C15.1833 21.7375 13.8833 22 12.5 22ZM12.5 20.5C14.8667 20.5 16.875 19.6708 18.525 18.0125C20.175 16.3542 21 14.35 21 12C21 9.63333 20.175 7.625 18.525 5.975C16.875 4.325 14.8667 3.5 12.5 3.5C10.15 3.5 8.14583 4.325 6.4875 5.975C4.82917 7.625 4 9.63333 4 12C4 14.35 4.82917 16.3542 6.4875 18.0125C8.14583 19.6708 10.15 20.5 12.5 20.5Z",
        fill: "currentColor"
      })
    ]
  });
}
export {
  CircularOutlineCheckIcon
};
//# sourceMappingURL=CircularOutlineCheckIcon.mjs.map